exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".select-container {\n    margin-bottom: 32px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.reason-codes-label {\n    color: #888992;\n    font-size: 14px;\n}\n.reason-codes-label-bold {\n    font-weight: 600;\n    font-size: 16px;\n    color: #080912;\n}\n.other-input-container {\n    margin-top: 24px;\n}\n.other-input {\n    border-radius: 6px;\n    border: 1px solid #BABBC4;\n    box-sizing: border-box;\n    margin-top: 8px;\n    outline: none;\n    padding: 4px;\n    resize: none;\n    width: 100%;\n}\n", ""]);

// exports
